import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Globe, Users, Clock } from 'lucide-react';

const STATS = [
  { icon: <FileText size={36} strokeWidth={1.5} />, value: '43,389+', label: 'T1/T2 Transit declarations processed' },
  { icon: <Globe    size={36} strokeWidth={1.5} />, value: '37',       label: 'Countries covered' },
  { icon: <Users    size={36} strokeWidth={1.5} />, value: '1,570+',   label: 'Satisfied clients' },
  { icon: <Clock    size={36} strokeWidth={1.5} />, value: '10–20 min',label: 'Average processing time' },
];

const Stats = () => (
  <section id="stats">
    <style>{`
      .stats-section {
        background: linear-gradient(135deg, #1a4fa0 0%, #2563eb 50%, #4792f4 100%);
        border-top: 1px solid rgba(71,146,244,0.30);
        padding: 4rem 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2.5rem;
      }

      /* ── Title bar ── */
      .stats-header {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        border-left: 4px solid rgba(255,255,255,0.6);
        padding-left: 0.85rem;
      }
      .stats-brand-name {
        font-size: 1.05rem;
        font-weight: 800;
        color: #ffffff;
        margin: 0;
        letter-spacing: 0.01em;
      }
      .stats-brand-sep {
        width: 1px;
        height: 1rem;
        background: rgba(255,255,255,0.4);
        flex-shrink: 0;
      }
      .stats-brand-sub {
        font-size: 1.05rem;
        font-weight: 400;
        color: rgba(255,255,255,0.75);
        margin: 0;
      }

      /* ── Grid ── */
      .stats-grid {
        max-width: 1000px;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 0;
      }
      .stats-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 2rem 1.5rem;
        text-align: center;
        gap: 0.75rem;
        border-right: 1px solid rgba(255,255,255,0.4);
        transition: background 0.2s;
      }
      .stats-card:last-child {
        border-right: none;
      }
      .stats-card:hover {
        background: rgba(255,255,255,0.1);
        border-radius: 12px;
      }
      .stats-icon {
        color: rgba(255,255,255,0.85);
      }
      .stats-value {
        font-size: clamp(1.8rem, 2.8vw, 2.5rem);
        font-weight: 800;
        color: #ffffff;
        line-height: 1;
        margin: 0;
        letter-spacing: -0.02em;
      }
      .stats-label {
        font-size: 0.85rem;
        color: rgba(255,255,255,0.75);
        margin: 0;
        line-height: 1.45;
        max-width: 140px;
      }

      @media (max-width: 760px) {
        .stats-grid {
          grid-template-columns: repeat(2, 1fr);
        }
        .stats-card {
          border-right: 1px solid rgba(255,255,255,0.4);
          border-bottom: 1px solid rgba(255,255,255,0.4);
        }
        .stats-card:nth-child(2n) { border-right: none; }
        .stats-card:nth-child(3),
        .stats-card:nth-child(4) { border-bottom: none; }
      }
      @media (max-width: 400px) {
        .stats-grid { grid-template-columns: 1fr 1fr; }
      }
    `}</style>

    <div className="stats-section">

      {/* Title */}
      <motion.div
        className="stats-header"
        initial={{ opacity: 0, x: -16 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <p className="stats-brand-name">GeoGlobalGate</p>
        <div className="stats-brand-sep" />
        <p className="stats-brand-sub">By the Numbers</p>
      </motion.div>

      {/* Cards */}
      <div className="stats-grid">
        {STATS.map((item, i) => (
          <motion.div
            key={i}
            className="stats-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1, duration: 0.45 }}
          >
            <div className="stats-icon">{item.icon}</div>
            <p className="stats-value">{item.value}</p>
            <p className="stats-label">{item.label}</p>
          </motion.div>
        ))}
      </div>

    </div>
  </section>
);

export default Stats;
